import React from 'react';
import { useParams } from 'react-router-dom';
import BillsToPay from '../../../components/Bills/ToPay/billsToPay';
import PageContent from '../../../components/Main/Content/mainContent';

const ContasPagar = () => {
  const { id } = useParams();

  return (
    <PageContent>
      <BillsToPay referenceId={id} />
    </PageContent>
  );
};

export default ContasPagar;
